(ns net.kestec.mhda-pilgrimage.public.application.form.application-form-step4
  (:require
    ["@mui/material/Typography" :default Typography]
    ["@mui/material/Grid" :default Grid]
    ["@mui/material/Chip" :default Chip]
    ["@mui/material/MenuItem" :default MenuItem]
    [net.kestec.mhda-pilgrimage.lib-ui.form-components :refer [grid-small grid-medium grid-full text-field text-field-multi checkbox select radio-yes-no]]
    [net.kestec.mhda-pilgrimage.lib-ui.form-validator :refer [form-field-validator form-validator check-combine-or check-min-text-length check-not-nil check-is-phone check-is-email]]
    [net.kestec.mhda-pilgrimage.public.application.application-events :as-alias application-events]
    [net.kestec.mhda-pilgrimage.db :as-alias db]
    [day8.re-frame.http-fx]
    [reagent.core :as r]
    [re-frame.core :as rf]
    ))


(def VALIDATOR
  {
   :insurance_provided        {:check-fn (check-combine-or (fn [data] (and (true? (:mhda_member data)) (= (:mhda_type data) "PE"))) (check-not-nil)) :error-text "Bitte eine Antwort wählen" :missing-text "Versicherung"}
   :insurance_booked          {}
   :selected_division         {:check-fn (check-not-nil) :error-text "Bitte eine Antwort wählen" :missing-text "Kontingent/Bundesland"}
   :single_room_booked        {:check-fn (check-combine-or (fn [data] (and (true? (:mhda_member data)) (= (:mhda_type data) "PE"))) (check-not-nil)) :error-text "Bitte eine Antwort wählen" :missing-text "Einzelzimmer?"}

   :room_wishes               {}

   :emergency_contact_name    {:check-fn (check-min-text-length 3) :error-text "Name mindestens 3 Zeichen" :missing-text "Notkontakt Email"}
   :emergency_contact_phone   {:check-fn (check-is-phone) :error-text "Telefonnummer mit Vorwahl +43664123456 mindestens 7 Zeichen" :missing-text "Notkontakt Email"}
   :emergency_contact_email   {:check-fn (check-is-email) :error-text "Email mindestens 8 Zeichen" :missing-text "Notkontakt Email"}

   :emergency_contact_name_2  {}
   :emergency_contact_phone_2 {:check-fn (check-combine-or (fn [data] (= (count (:emergency_contact_name_2 data)) 0)) (check-is-phone)) :error-text "Telefonnummer mit Vorwahl +43664123456 mindestens 7 Zeichen" :missing-text "Notkontakt Email"}
   :emergency_contact_email_2 {:check-fn (check-combine-or (fn [data] (= (count (:emergency_contact_name_2 data)) 0)) (check-is-email)) :error-text "eine gültige Email Adresse (xy@domain.xy)" :missing-text "Notkontakt Email"}
   })


(defn main []
  (let [!application (rf/subscribe [::db/get ::db/selected-application])
        field-validator (form-field-validator VALIDATOR !application)
        form-valid (form-validator VALIDATOR !application)]
    [:> Grid {:container true}
     [grid-full [:> Typography {:variant "h3"} "4. Reisedetails / Notfallkontakt"]]
     (if (not (and (true? (:mhda_member @!application)) (= (:mhda_type @!application) "PE")))
       [:<>
        [grid-full [:> Typography {:variant "h5"} "Reiseversicherung"]]
        [grid-full
         [radio-yes-no
          {:label      "Ich habe eine Reiseversicherung (ÖAMTC Mitglied, VISA, AMEX)"
           :value      (:insurance_provided @!application)
           :error      (:error (field-validator :insurance_provided))
           :helperText (:helperText (field-validator :insurance_provided))
           :onChange   #(rf/dispatch [::application-events/store-value :insurance_provided %])
           }]]


        [grid-full
         [checkbox {:label      (r/as-element [:p "Ich möchte zusätzlich die MALTESER Reise-Unfall- und Krankenversicherung zum Preis von 20 €" [:br]
                                               [:span {:style {:font-size "0.7rem"}} "Versicherungspartner ist die Generali Versicherung. "
                                                " Überweisung des Betrags bitte gemeinsam mit dem Reisepreis."]
                                               ])
                    :value      "insurance_booked"
                    :error      (:error (field-validator :insurance_booked))
                    :helperText (:helperText (field-validator :insurance_booked))
                    :checked    (:insurance_booked @!application)
                    :onChange   (fn [b v]
                                  (js/console.log "onChange -- " v "-" b)
                                  (rf/dispatch [::db/set-in! [::db/selected-application :insurance_booked] b])
                                  )}]]])
     [grid-full
      ]

     [grid-full [:> Typography {:variant "h5"} "Für das Bundesland"]]
     [grid-medium
      [select {:value      (or (:selected_division @!application) "")
               :fullWidth  true
               :label      "Kontingent /Bundesland"
               :error      (:error (field-validator :selected_division))
               :helperText (:helperText (field-validator :selected_division))
               :onChange   #(rf/dispatch [::application-events/store-value :selected_division %])}
       [:> MenuItem {:value ""} "-- keine Ahnung --"]
       [:> MenuItem {:value "B"} "Burgenland"]
       [:> MenuItem {:value "OO"} "Oberösterreich"]
       [:> MenuItem {:value "Sb"} "Salzburg"]
       [:> MenuItem {:value "St"} "Steiermark/Kärnten"]
       [:> MenuItem {:value "T"} "Tirol/Vorarlberg"]
       [:> MenuItem {:value "W"} "Wien/Niederösterreich"]
       (when (:mhda_member @!application) [:> MenuItem {:value "Bu"} "Bund/Einsatzleitung"])
       ]]

     (if (not (and (true? (:mhda_member @!application)) (= (:mhda_type @!application) "PE")))
       [:<> [grid-full [:> Typography {:variant "h5"} "Zimmerwunsch (optional)"]]
        [grid-full
         [radio-yes-no
          {:label      "Ich möchte nach Möglichkeit ein Einzelzimmer und bin bereit die Mehrkosten von 200 € zu tragen."
           :value      (:single_room_booked @!application)
           :error      (:error (field-validator :single_room_booked))
           :helperText (:helperText (field-validator :single_room_booked))
           :onChange   #(rf/dispatch [::application-events/store-value :single_room_booked %])
           }]
         [:br]
         [:span {:style {:font-size "0.7rem"}}
          "Einzelzimmer können nur nach Eingang der Mehrkosten vergeben werden."
          " Sollten Sie kein Einzelzimmer bekommen, werden wir den Betrag zurück überweisen."]
         [:br] [:br]]])

     [grid-full
      [text-field-multi {:label      "Bei der Wallfahrt möchte ich das Zimmer teilen mit"
                         :value      (or (:room_wishes @!application) "")
                         :onChange   #(rf/dispatch [::application-events/store-value :room_wishes %])
                         :error      (:error (field-validator :room_wishes))
                         :helperText (:helperText (field-validator :room_wishes))
                         }]
      ]


     [grid-full [:> Typography {:variant "h5"} "Notfallkontakt"]]
     [grid-full [:> Typography {:variant "p"} "In einem Notfall bitte verständigen: "]]
     [grid-small
      [text-field {:label      "1.Kontakt Name"
                   :value      (:emergency_contact_name @!application)
                   :onChange   #(rf/dispatch [::application-events/store-value :emergency_contact_name %])
                   :error      (:error (field-validator :emergency_contact_name))
                   :helperText (:helperText (field-validator :emergency_contact_name))}]]
     [grid-small
      [text-field {:label      "1.Kontakt Telefonnummer"
                   :value      (:emergency_contact_phone @!application)
                   :onChange   #(rf/dispatch [::application-events/store-value :emergency_contact_phone %])
                   :error      (:error (field-validator :emergency_contact_phone))
                   :helperText (:helperText (field-validator :emergency_contact_phone))}]]
     [grid-small
      [text-field {:label      "1.Kontakt Email"
                   :value      (:emergency_contact_email @!application)
                   :onChange   #(rf/dispatch [::application-events/store-value :emergency_contact_email %])
                   :error      (:error (field-validator :emergency_contact_email))
                   :helperText (:helperText (field-validator :emergency_contact_email))}]]
     [grid-small
      [text-field {:label      "2.Kontakt Name (optional)"
                   :value      (:emergency_contact_name_2 @!application)
                   :onChange   #(rf/dispatch [::application-events/store-value :emergency_contact_name_2 %])
                   :error      (:error (field-validator :emergency_contact_name_2))
                   :helperText (:helperText (field-validator :emergency_contact_name_2))}]]
     [grid-small
      [text-field {:label      "2.Kontakt Telefonnummer"
                   :value      (:emergency_contact_phone_2 @!application)
                   :onChange   #(rf/dispatch [::application-events/store-value :emergency_contact_phone_2 %])
                   :error      (:error (field-validator :emergency_contact_phone_2))
                   :helperText (:helperText (field-validator :emergency_contact_phone_2))}]]
     [grid-small
      [text-field {:label      "2.Kontakt Email"
                   :value      (:emergency_contact_email_2 @!application)
                   :onChange   #(rf/dispatch [::application-events/store-value :emergency_contact_email_2 %])
                   :error      (:error (field-validator :emergency_contact_email_2))
                   :helperText (:helperText (field-validator :emergency_contact_email_2))}]]

     [grid-full
      ;[:pre (pr-str form-valid)]
      (when-not (:valid form-valid)
        (into [:<> "Es fehlen noch folgende Eingaben: "]
              (for [missing (:formMissingText form-valid)]
                [:> Chip {:label (str missing) :sx {:backgroundColor "var(--color-mhda-red)" :color "var(--color-mhda-red-text)"}}])
              ))
      ]

     ]))